/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ValidationErrors } from '@angular/forms';
import { isObservable } from '@gh/core-util';
import { of$ } from '@gh/rx';
import { switchMap$ } from '@gh/rx/operators';
import { Observable, Subject } from 'rxjs';
import { EditableCellState, GridModel, GridState } from './grid-state.interfaces';
import { StateBasedGridModel } from './state-based-grid-model';

export function createSimpleGridModel<T>(getId: TransformFn<T, any>): GridModel {
  return new StateBasedGridModel(new SimpleGridState(getId));
}

export class SimpleGridState<T> implements GridState<T> {
  editable = of$(true);
  private rowData$$ = new Subject<any[]>();

  constructor(private getId: TransformFn<T, any>) {
  }

  get rowData(): Observable<any[]> {
    return this.rowData$$.pipe(
      switchMap$((data) => isObservable(data) ? data : [data]));
  }

  getEntityId(entity: T): any {
    return this.getId(entity);
  }

  getState(entity: T, name: string): EditableCellState {
    this.notSupported('getState');
    return <any>void 0;
  }

  getValue(name: string, state: EditableCellState): any {
    this.notSupported('getValue');
    return <any>void 0;
  }

  isEditable(entity: T, name: string): boolean {
    this.notSupported('isEditable');
    return <any>void 0;
  }

  isRequired(entity: T, name: string): boolean {
    this.notSupported('isRequired');
    return <any>void 0;
  }

  setData(data: any): void {
    this.rowData$$.next(data);
  }

  setValue(entity: T, name: string, value: any): void {
    this.notSupported('setValue');
    return <any>void 0;
  }

  validate(entity: T, name: string, value: any): Maybe<ValidationErrors> {
    this.notSupported('validate');
    return <any>void 0;
  }

  private notSupported(methodName: string): void {
    throw new Error(`DummyGridState: method "${methodName}" is not implemented.
     Use DefaultGridState if you need editable cells`);
  }
}
